export default __webpack_public_path__ + "static/ensino-fundamental-active-55a876a26456d4db00ba01656b4152c6.svg";